<template>
    <span @click.stop="setGroceryListFormState">
        <svg class="icon icon-plus">
            <use xlink:href="#icon-plus"></use>
        </svg>
        <span>Spara i din inköpslista</span>
    </span>
</template>
<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: {
        recipe: Number,

        servings: {
            type: [Number],
            default: null
        },

        menu: {
            type: [Number],
            default: null
        }
    },

    data() {
        return {
            state
        };
    },

    methods: {

        setGroceryListFormState() {

            axios
                .post('/api/shopping-list/recipe-items', {
                    recipe_id: this.recipe,
                    servings: this.servings,
                    menu_id: this.menu
                })
                .then((response) => {

                    if (response.data) {

                        this.state.groceryListForm.active = !this.state.groceryListForm.active;

                        this.state.groceryListForm.recipeId = response.data.recipe_id;

                        this.state.groceryListForm.ingredients = response.data.ingredients;

                        this.state.groceryListForm.recipeServings = response.data.servings;
                    }
                });
        }
    }
};
</script>
